"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.algoliaServer = void 0;
const algoliasearch_1 = require("algoliasearch");
const ErrorMessage_1 = require("../constants/ErrorMessage");
const algoliaServer = (appId, apiKey, options) => {
    const algoliaInstance = (0, algoliasearch_1.algoliasearch)(appId, apiKey);
    return {
        /**
         * To Search from a single.
         * @param {String} params.indexName - Algolia target index
         * @param {Object} params.searchParams - Search params like filter, query etc.
         * @param {Object} reqOption - Optional reqOptions like header etc.
         * @returns {Promise<Object>} Multi-index search results.
         */
        search: async (params, reqOption) => {
            return algoliaInstance.searchSingleIndex(params, reqOption);
        },
        /**
         * To Search from a single.
         * @param {String} params.indexName - Algolia target index
         * @param {Object} params.browseParams - browse params like filter, query etc.
         * @param {Object} reqOption - Optional reqOptions like header etc.
         * @returns {Promise<Object>} Multi-index search results.
         */
        browse: async (params, reqOption) => {
            return algoliaInstance.browse(params, reqOption);
        },
        /**
         * To Search from a multi-indexes.
         * @param {Array<Object>} searchParams - Search parameters for each index.
         * @param {string} strategy - Strategy for search execution.
         * @returns {Promise<Object>} Multi-index search results.
         */
        multiIndexSearch: async (searchParams, strategy, reqOption) => {
            return algoliaInstance.search({ requests: searchParams, strategy }, reqOption);
        },
        /**
         * Searches for stores by latitude and longitude.
         * @typedef {Object} StoreByLatLngParamsType
         * @throws {Error} If no index name is provided.
         * @returns {Promise<Object>} Search results.
         */
        storeSearchByLatLng: async (params) => {
            const { lat, lng, hitsPerPage = 20, page = 0, query = "", indexName = "", ...rest } = params;
            const index = indexName || options?.indexName;
            if (!index) {
                throw new Error(ErrorMessage_1.ErrorMessages.INVALID_INDEX);
            }
            return algoliaInstance.searchSingleIndex({
                indexName: index,
                searchParams: {
                    query: query,
                    aroundLatLng: lat + ", " + lng,
                    hitsPerPage,
                    page,
                    aroundRadius: "all",
                    ...rest,
                },
            });
        },
    };
};
exports.algoliaServer = algoliaServer;
